/**
 * 仪表盘表格文本选取守卫 — 清除 RAC usePress 的 inline `user-select: none`。
 * 挂在 AppShell；覆盖 HeroUI Table 根；与 globals `select-text`（无 !important）配合。
 */

import { useEffect } from "react";

import { clearDataTablePressUserSelectLock } from "@/lib/ui/copyable-table-cell";

export const DataTableTextSelectionGuard = () => {
  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      clearDataTablePressUserSelectLock(event.target);
    };
    document.addEventListener("pointerdown", onPointerDown, false);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown, false);
    };
  }, []);

  return null;
};
